import React from "react";
import "./vacancySearch.css";

const VacancySearch = () => {
  const jobs = [
    {
      title: "Bike Riders",
      Requirements: "Immediately (with or without SL bike license)",
      location: "UAE",
      description: "Visa, Accommodation, Insurance and Driving license will be provided",
    },
    {
      title: "Building Masons(American based company)",
      Requirements: "Immediately",
      location: "UAE",
      description: "Visa and Air tickets will be provided (salary will be in USD)",
    },
    {
      title: "Security and Life Guards",
      Requirements: "Immediately (with or without experience)",
      location: "UAE",
      description: "Visa, Accommodation, Insurance will be provided",
    },
    {
      title: "Factory Workers",
      Requirements: "Immediately (with or without experience)",
      location: "UAE",
      description: "Visa, Accommodation, Insurance will be provided",
    },
    {
      title: "E-Picker",
      Requirements: "Knowledge in English and Computer",
      location: "UAE",
      description: "Goods are selected from inventory and assembled for shipment to customer orders",
    },
    {
      title: "Chinese Cook",
      Requirements: "Immediately (with experience)",
      location: "Sri Lanka",
      description: "Salary will be provided in Dirham(UAE)",
    },
  ];

  return (
    <div>
      {/* <section className="search">
        <h2>Find Your Dream Job</h2>
        <form action="#" method="get">
          <input type="text" name="keywords" placeholder="Keywords" />
          <input type="text" name="location" placeholder="Location" />
          <input type="text" name="company" placeholder="Company" />
          <button type="submit">Search</button>
        </form>
      </section> */}
      <section className="job-listings">
        <h2 className="job-h2">Latest Job Listings</h2>
        <ul className="job-ul">
          {jobs.map((job, index) => (
            <li key={index}>
              <h3>{job.title}</h3>
              <p>Requirements: {job.Requirements}</p>
              <p>Location: {job.location}</p>
              <p>Description: {job.description}</p>
              <a href="mailto:stannum.hrconsultancy@gmail.com">Apply Now</a>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default VacancySearch;